"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.NoteOutlineSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M29.04,19.88l-.23-.14C27.76,19.13,26,18.11,26,14V6a2.0059,2.0059,0,0,0-2-2H4A2.0059,2.0059,0,0,0,2,6V26a2.0059,2.0059,0,0,0,2,2H24a2.0059,2.0059,0,0,0,2-2V24h2a2.0059,2.0059,0,0,0,2-2v-.42A1.9716,1.9716,0,0,0,29.04,19.88ZM24,26H4V21.08a9.433,9.433,0,0,0,3.63,2.85A.9349.9349,0,0,0,8,24H24Zm4-4H8.21A7.5876,7.5876,0,0,1,4,15V6H24v8c0,3.22.96,5.03,2,6.11a7.4779,7.4779,0,0,0,1.8,1.36l.2.11Z"/><path d="M7,11h8a1,1,0,0,0,0-2H7a1,1,0,0,0,0,2Zm8-1h0Z"/><path d="M20,13H7a1,1,0,0,0,0,2H20a1,1,0,0,0,0-2ZM7,14H7Z"/>';
var NoteOutlineSVG = function NoteOutlineSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.NoteOutlineSVG = NoteOutlineSVG;
NoteOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(NoteOutlineSVG);
exports.default = _default;